import React from 'react'
import { up } from 'styled-breakpoints'
import styled from 'styled-components'
import { StoreList } from '../../../config'

import StoreButton from './store-button'

const stores: Array<{ name: keyof StoreList, image: string }> = [
    {
        name: 'apple',
        image: require('./images/apple_store.svg'),
    },
    {
        name: 'android',
        image: require('./images/google_play.svg'),
    },
]

const AppStore: React.FunctionComponent = () => (
    <Container>
        {stores.map((s, i) => <StoreButton key={i} {...s} even={i % 2 === 0}/>)}
    </Container>
)

const Container = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;

    justify-items: center;
    align-items: center;

    width: 280px;
    height: fit-content;

    ${up('mobileBig')} {
        width: 320px;
    }
`

export default AppStore